export default "__VITE_ASSET__8762a70d__"